/*
 * SecureRNG.java
 */
export class SecureRNG {
    nextBoolean(weighting) {
        return Math.random() < weighting;
    }
    nextDouble() {
        return Math.random();
    }
    nextInt(inclusiveLowerBound, exclusiveUpperBound) {
        return (inclusiveLowerBound +
            Math.floor(Math.random() * (exclusiveUpperBound - inclusiveLowerBound)));
    }
}
//# sourceMappingURL=SecureRNG.js.map